import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import {  RootWiseCostService } from "./root-wise-cost.service";
import { CommonResponseModel, CostDto, driverIdReq, KmsDto, RootwiseCostResponseModel, RouteCostIdreq, VehicleReqId } from "@project-management-system/shared-models";

@ApiTags('/rootwisecost')
@Controller('rootwisecost')
export class RootWiseCostController {
    constructor(
        private rootwisecostService: RootWiseCostService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ) { }

    @Post('/createRootwisecost')
    @ApiBody({ type: CostDto })
    async createRootwisecost(@Body() req:any): Promise<RootwiseCostResponseModel> {
        // console.log(req,"hhhhhhhhhh");
        try {
            return await this.rootwisecostService.createRootWisecost(req,false);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(RootwiseCostResponseModel, error)
        }
    }

    @Post('/updateRootwisecost')
    async updateRootwisecost(@Body() req:any): Promise<RootwiseCostResponseModel> {
        try {
            return await this.rootwisecostService.createRootWisecost(req,true);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(RootwiseCostResponseModel, error)
        }
    }

    @Post('/getAllRootwisecostInfo')
    @ApiBody({ type:RouteCostIdreq })
    async getAllRootwisecostInfo(@Body() req:any): Promise<RootwiseCostResponseModel> {
        try {
            return await this.rootwisecostService.getAllRootwiseCostInfo(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(RootwiseCostResponseModel, error)
        }
    }

    @Post('/activateOrDeactivateRootwisecost')
    async activateOrDeactivateRootwisecost(@Body() req:any): Promise<RootwiseCostResponseModel> {
        try {
            return await this.rootwisecostService.activateOrDeactivateRootwiseCost(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(RootwiseCostResponseModel, error)
        }
    }

    @Post('/getAllActiveRootwisecost')
    async getAllActiveRootwisecost(): Promise<RootwiseCostResponseModel> {
        try {
            return await this.rootwisecostService.getAllActiveRootWiseCostInfo();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(RootwiseCostResponseModel, error)
        }
    }

    @Post('/getCost')
    @ApiBody({ type: KmsDto })
    async getCost(@Body() req:any): Promise<CommonResponseModel> {
        try {
            return await this.rootwisecostService.getCost(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponseModel, error)
        }
    }

    @Post('/getExactSlabCost')
    @ApiBody({ type: KmsDto })
    async getExactSlabCost(@Body() req:any): Promise<CommonResponseModel> {
        try {
            return await this.rootwisecostService.getExactSlabCost(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponseModel, error)
        }
    }

    @Post('/getRouteById')
    @ApiBody({ type: VehicleReqId })
    async getRouteById(@Body() req:any): Promise<CommonResponseModel> {
        try {
            return await this.rootwisecostService.getRouteById(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponseModel, error)
        }
    }
    @Post('/vehcileTypeFromrootwisecost')
    async vehcileTypeFromrootwisecost(): Promise<CommonResponseModel> {
        try {
            return await this.rootwisecostService.vehcileTypeFromrootwisecost();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponseModel, error)
        }
    }

    

}